<div class="container-fluid p-6">
    <div class="row mb-4">
        <div class="col">
            <h6 class="mb-2">Entwicklung einer datengestützten Softwarelösung für das Diversity-Management</h6>
            <h2>Diversitize App</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                Die Diversitize GmbH unterstützt Unternehmen und Organisationen dabei, Vielfalt in der digitalen Transformation zu fördern, indem sie Diversity Management und Gleichstellungsarbeit digitalisiert und professionalisiert. Mit datengestützten Tools und maßgeschneiderten Trainings hilft Diversitize, Diversity-Ziele zu definieren, Maßnahmen zu planen und Erfolge transparent zu machen, um Vielfalt als Erfolgsfaktor nachhaltig in Unternehmenskultur und -strategie zu verankern.
            </p>
            <p>
                Die zu entwickelnde Applikation soll eine datengestützte Online-Softwarelösung darstellen, die Unternehmen dabei unterstützt, Diversity-Maßnahmen strategisch zu planen, umzusetzen und deren Fortschritte transparent zu analysieren.
            </p>
        </div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="col-xl-4">
            <h2>TASK & CHALLENGE</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Im Rahmen des Projekts war die Entwicklung einer standardisierten Schnittstelle erforderlich, um den reibungslosen Import von Mitarbeiterdaten sicherzustellen. Diese Daten mussten anschließend verarbeitet und in benutzerfreundlichen, intuitiv verständlichen Charts visualisiert werden. Darüber hinaus war es essentiell, relevante KPIs zu identifizieren und zu berechnen, um eine fundierte strategische Planung sowie eine effektive Überwachung der Unternehmensziele zu ermöglichen.
            </p>
            <img src="/assets/images/references/ref-diversitize-charts.png" class="img-fluid" />
        </div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="col-xl-4">
            <h2>SOLUTION</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Die entwickelte Lösung bietet einen einfachen und effizienten Datenimport, der eine nahtlose Integration gewährleistet. Eine Vielzahl individuell anpassbarer Charts ermöglicht es, Daten gezielt nach den jeweiligen Zielvorgaben zu visualisieren und auszuwerten. Die benutzerfreundliche Oberfläche sorgt für eine intuitive Bedienung und erleichtert die Nutzung auch für technisch weniger versierte Anwender. Als cloud basierte SaaS-Lösung ist das System jederzeit und überall verfügbar, während die browserbasierte Architektur eine plattformunabhängige Nutzung ermöglicht. Diese Kombination garantiert Flexibilität, Skalierbarkeit und eine optimale Anwendererfahrung.
            </p>
            <div style="margin-top: 2rem">
                <h4>TECHNOLOGIEN</h4>
                <div class="tech-icons">
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/Infront JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/HTML5 CSS3@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/nodejs@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/SQL@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/Google Cloud@2x-1.png" />
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-12">
            <div class="p-2 p-lg-5" style="border: 1px solid white;">
                <p>
                    “Die aheadware GmbH hat unsere Anforderungen nicht nur schnell und kosteneffizient umgesetzt, sondern dabei auch ein beeindruckendes Maß an Professionalität gezeigt. Das Team hat unser Themengebiet vollständig verstanden und mit durchdachten, technischen Vorschlägen eine Lösung entwickelt, die unsere Erwartungen weit übertroffen hat. Das Besondere an der Zusammenarbeit war für mich, dass aheadware die Anforderungen nicht nur professionell umgesetzt hat, sondern man auch merkte, dass sie sich wirklich in die zu entwickelnde Lösung hineingedacht und mit eigenen Vorschlägen die Umsetzung optimiert haben. So etwas ist nicht selbstverständlich und hat die Lösung noch besser gemacht.”
                </p>
                <p>
                    <i>Dr. Miriam Stehling, Gründerin & Geschäftsführerin</i>
                </p>
            </div>
        </div>
    </div>
</div>
